export default "__VITE_ASSET__DRw1Hg1c__"